export default __webpack_public_path__ + "static/media/intro.3548d9d7.md";